import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate, useParams, useSearchParams, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { PageCard } from 'components/Layout';
import RepaymentTypeTooltip from 'components/InfoTooltip/RepaymentTypeTooltip';

import PersonalInfoImage from 'assets/images/personal_info.png';
import LoanDetailsImage from 'assets/images/loan_details.png';
import VerifyIdentityImage from 'assets/images/verify_identity.png';
import ConnectBankImage from 'assets/images/connect_bank.png';
import SelectOfferImage from 'assets/images/select_offer.png';
import FundingAccountImage from 'assets/images/funding_account.png';
import CollateralDepositImage from 'assets/images/collateral_deposit.png';
import WelcomeBackImage from 'assets/images/welcome_back.png';
import PendingImage from 'assets/images/pending.png';
import CreditFreezeImage from 'assets/images/credit_freeze.png';
import MicroDepositImage from 'assets/images/micro_deposit.svg';
import PhoneVerificationImage from 'assets/images/phone_verification.svg';
import VerificationFailedImage from 'assets/images/verification_failed.svg';
import ConfirmMicroDepositImage from 'assets/images/confirm_micro_deposit.svg';

import PersonalInfoPage from './pages/PersonalInfo';
import LoanDetailsPage from './pages/LoanDetails';
import VerifyIdentityPage from './pages/VerifyIdentity';
import ConnectBankPage from './pages/ConnectBank';
import InstantVerificationPage from './pages/InstantVerification';
import ManualVerificationPage from './pages/ManualVerification';
import ReviewBankAccountsPage from './pages/ReviewBankAccounts';
import DeclinedPage from './pages/Declined';
import BlockedPage from './pages/Blocked';
import CreditFreezePage from './pages/CreditFreeze';
import PendingPage from './pages/Pending';
import CheckinPage from './pages/Checkin';
import WelcomeBackPage from './pages/WelcomeBack';
import SelectOfferPage from './pages/SelectOffer';
import RepromptingPage from './pages/Reprompting';
import KBAFailurePage from './pages/KBAFailure';
import GeneralErrorPage from './pages/GeneralError';
import FundingAccountPage from './pages/FundingAccount';
import AutoPayPage from './pages/AutoPay';
import CollateralDepositPage from './pages/CollateralDeposit';
import CollateralReturnPage from './pages/CollateralReturn';
import CollateralReturnOnTheWayPage from './pages/CollateralReturnOnTheWay';
import KBAIdentityVerificationPage from './pages/KBAIdentityVerification';
import KBAIdentityQuestionsPage from './pages/KBAIdentityQuestions';
import ManualAccountReviewPage from './pages/ManualAccountReview';
import ContractSigningPage from './pages/ContractSigning';
import CheckYourPhonePage from './pages/CheckYourPhone';
import OtpPage from './pages/Otp';
import ExistingApplicationPage from './pages/ExistingApplication';
import RedirectionPage from './pages/Redirection';
import AllSetPage from './pages/AllSet';
import CollateralDepositReviewPage from './pages/CollateralDepositReview';
import PhoneVerificationPage from './pages/PhoneVerification';
import MicroDepositOnTheWayPage from './pages/MicroDepositOnTheWay';
import ConfirmMicroDepositPage from './pages/ConfirmMicroDeposit';
import VerificationFailedPage from './pages/VerificationFailed';

export const routes = [
  {
    title: 'Access Cash',
    name: 'Without Selling Your Crypto',
    pathname: '/',
    component: LoanDetailsPage,
    image: LoanDetailsImage,
    exact: true,
    step: 'loan-details',
  },
  {
    name: 'Checkin',
    pathname: '/checkin',
    component: CheckinPage,
    exact: true,
  },
  {
    pathname: '/redirection',
    component: RedirectionPage,
    image: WelcomeBackImage,
    exact: true,
  },
  {
    name: 'Personal Info',
    pathname: '/personal-info',
    component: PersonalInfoPage,
    image: PersonalInfoImage,
    exact: true,
  },
  {
    name: 'Verify Identity',
    description: 'A quick ID and selfie check helps protect your account. Your info is securely encrypted throughout the process.',
    pathname: '/verify-identity',
    component: VerifyIdentityPage,
    image: VerifyIdentityImage,
    exact: true,
  },
  {
    name: 'Verify Identity',
    pathname: '/check-your-phone',
    component: CheckYourPhonePage,
    image: VerifyIdentityImage,
    exact: true,
    step: 'verify-identity',
  },
  {
    name: 'Verification Code',
    pathname: '/verify-otp',
    component: OtpPage,
    image: VerifyIdentityImage,
    exact: true,
  },
  {
    pathname: '/existing-application',
    component: ExistingApplicationPage,
    image: VerifyIdentityImage,
    exact: true,
    step: 'verify-identity',
  },
  {
    name: 'Connect Your Bank',
    pathname: '/connect-bank',
    description: 'Choose your preferred method to provide us with your banking information',
    component: ConnectBankPage,
    image: ConnectBankImage,
    exact: true,
  },
  {
    name: 'Instant Verification',
    pathname: '/instant-verification',
    component: InstantVerificationPage,
    image: ConnectBankImage,
    exact: true,
    step: 'connect-bank',
  },
  {
    name: 'Manual Verification',
    pathname: '/manual-verification',
    component: ManualVerificationPage,
    image: ConnectBankImage,
    exact: true,
    step: 'connect-bank',
  },
  {
    name: 'Review Statements',
    pathname: '/review-bank-accounts',
    component: ReviewBankAccountsPage,
    image: ConnectBankImage,
    exact: true,
    step: 'connect-bank',
  },
  {
    name: 'Collateral Deposit',
    pathname: '/collateral-deposit',
    component: CollateralDepositPage,
    image: CollateralDepositImage,
    exact: true,
  },
  {
    name: 'Return Wallet Address',
    pathname: '/collateral-return',
    component: CollateralReturnPage,
    image: CollateralDepositImage,
    exact: true,
  },
  {
    name: 'Your Return Is on the Way',
    pathname: '/collateral-return-on-the-way',
    component: CollateralReturnOnTheWayPage,
    image: CollateralDepositImage,
    exact: true,
  },
  {
    name: 'Declined',
    pathname: '/declined',
    component: DeclinedPage,
    exact: true,
  },
  {
    name: 'Blocked',
    pathname: '/blocked',
    component: BlockedPage,
    exact: true,
  },
  {
    name: 'Your Credit is Frozen',
    pathname: '/credit-freeze',
    component: CreditFreezePage,
    image: CreditFreezeImage,
    exact: true,
  },
  {
    name: 'Application Pending',
    pathname: '/pending',
    component: PendingPage,
    image: PendingImage,
    exact: true,
  },
  {
    pathname: '/welcome-back',
    component: WelcomeBackPage,
    image: WelcomeBackImage,
    exact: true,
  },
  {
    name: 'Select A Loan Offer',
    pathname: '/select-offer',
    component: SelectOfferPage,
    image: SelectOfferImage,
    description: 'Please review your selected offer and proceed to the next step.',
    tooltip: <RepaymentTypeTooltip color="slate-600" hoverColor="blue-700" position="bottom" />,
    exact: true,
  },
  {
    name: 'Funding Account Setup',
    pathname: '/funding-account',
    component: FundingAccountPage,
    image: FundingAccountImage,
    exact: true,
  },
  {
    name: 'Reduce Your Rate with Auto-Pay',
    description: `You can qualify for a 0.25% interest rate reduction by enrolling in Auto-Pay today, and you'll stay on track with every payment.`,
    pathname: '/autopay',
    component: AutoPayPage,
    image: FundingAccountImage,
    exact: true,
  },
  {
    name: 'Reprompting',
    pathname: '/reprompting',
    component: RepromptingPage,
    exact: true,
  },
  {
    name: 'Identity Verification',
    pathname: '/identity/verification',
    image: PersonalInfoImage,
    component: KBAIdentityVerificationPage,
    exact: true,
  },
  {
    name: 'Identity Verification',
    pathname: '/identity/questions',
    image: PersonalInfoImage,
    component: KBAIdentityQuestionsPage,
    exact: true,
  },
  {
    name: 'KBA Failure',
    pathname: '/identity/manual-verification',
    component: KBAFailurePage,
    exact: true,
  },
  {
    name: 'General Error',
    pathname: '/error',
    component: GeneralErrorPage,
    exact: true,
  },
  {
    name: 'Manual Account Review',
    pathname: '/manual-account-review',
    component: ManualAccountReviewPage,
    exact: true,
  },
  {
    name: 'Contract Signing',
    pathname: '/contract-signing',
    component: ContractSigningPage,
    exact: true,
  },
  {
    name: 'All Set',
    pathname: '/all-set',
    component: AllSetPage,
    exact: true,
  },
  {
    name: 'Verification in Progress',
    pathname: '/collateral-deposit-review',
    component: CollateralDepositReviewPage,
    image: PendingImage,
    exact: true,
  },
  {
    name: 'Last Step: Phone Verification',
    pathname: '/phone-verification',
    component: PhoneVerificationPage,
    image: PhoneVerificationImage,
    exact: true,
  },
  {
    name: 'Verification Failed',
    pathname: '/verification-failed',
    component: VerificationFailedPage,
    image: VerificationFailedImage,
    exact: true,
  },
  {
    name: 'Your micro-deposit is on the way',
    pathname: '/micro-deposit-on-the-way',
    component: MicroDepositOnTheWayPage,
    image: MicroDepositImage,
    exact: true,
  },
  {
    name: 'Confirm your micro-deposit',
    pathname: '/confirm-micro-deposit',
    component: ConfirmMicroDepositPage,
    image: ConfirmMicroDepositImage,
    exact: true,
  },
];

const AppRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Routes>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.pathname}
          element={(
            <PageCard route={route}>
              <route.component
                location={location}
                navigate={navigate}
                params={params}
                searchParams={searchParams}
                dispatch={dispatch}
              />
            </PageCard>
          )}
          {...(route.exact && { exact: route.exact })}
        />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
